<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <v-spacer />
      </v-col>
      <v-col v-if="evacuees.length > 0" :cols="5">
        <v-form autocomplete="off" @submit.prevent="identevacuation">
          <div>Identifizierungscode:</div>
          <v-text-field
            v-model="evacueeident"
            type="text"
            hint="Token oder alternative Identifizierung"
            autofocus
            class="hidden-text"
            outlined
            solo
            clearable
            :loading="error"
            light
            align="center"
            justify="center"
          />
        </v-form>
        <v-alert
          v-if="errorState"
          :value="errorState"
          color="red"
          dark
          border="top"
          icon="mdi-cloud-alert"
          transition="scale-transition"
        >
          {{ errorMessage }}
        </v-alert>
        <v-spacer />
      </v-col>
      <v-col>
        <v-spacer />
      </v-col>
    </v-row>
    <v-row v-if="evacuees.length > 0">
      <v-col>
        <v-progress-linear
          height="35"
          color="success"
          :value="statistics.evacueesevacuatedpercentage"
          striped
        >
          <v-card>
            <strong
              >Evakuierungsfortschritt:
              {{ Math.round(statistics.evacueesevacuatedpercentage) }}% ({{
                statistics.evacueesevacuated
              }}
              / {{ statistics.evacueescount }}, Verbleibend:
              {{ statistics.evacueesremainingcount }})</strong
            >
          </v-card>
        </v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-if="evacuees.length === 0">
      <v-col>
        <v-alert border="left" elevation="24" prominent type="success">
          Keine laufende Evakuierung
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="evacuees.length === 0">
      <v-col>
        <v-btn block color="warning" x-large @click.stop="updateEvacuees()">
          <v-icon left> mdi-reload </v-icon>Aktualisieren
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <LiveEvacuationTable
          v-if="evacuees.length > 0"
          :timeractive="timeractive"
          @setTimerStatus="setTimerStatus"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LiveEvacuationTable from "./tables/LiveEvacuationTable.vue";
import { mapState, mapGetters } from "vuex";
const aerraudio = new Audio("/assets/audio/sound_err.mp3");
const succaudio = new Audio("/assets/audio/sound_succ.mp3");

export default {
  name: "LiveEvacuation",
  components: {
    LiveEvacuationTable,
  },
  beforeRouteLeave(to, from, next) {
    this.setTimerStatus(false);
    this.timeractive = false;
    next();
  },
  data() {
    return {
      msg: "LiveEvacuation",
      evacueeident: "",
      errorMessage: "",
      timeractive: true,
      error: false,
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.auth.user,
      evacueesState: (state) => state.evacuees.evacuees,
    }),
    ...mapGetters("evacuees", {
      evacuees: "evacuees",
      statistics: "statistics",
      latestactiveevacuationid: "latestactiveevacuationid",
    }),
    errorState: {
      get() {
        return this.$store.state.evacuees.error;
      },
      set(value) {
        this.$store.dispatch("setErrorState", value);
      },
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    setTimerStatus(value) {
      this.timeractive = value;
    },
    initialize() {
      this.$store.dispatch("evacuees/updateData");
      this.$store.dispatch("evacuees/updateLatestActiveEvacuationID");
      this.$store.dispatch("evacuees/updateStatistics");
      this.error = false;
    },
    identevacuation: function () {
      const payload = {
        evacuationtype: "ident",
        evacuationid: this.$store.state.evacuees.latestactiveevacuationid,
        evacueeid: null,
        evacueeident: this.evacueeident,
        submittinguserid: this.currentUser.user_id,
        submittingusername: this.currentUser.name,
      };

      this.$store
        .dispatch("evacuees/evacuateEvacuee", payload)
        .then(() => {
          this.error = false;
          this.errorMessage = "";
          succaudio.play();
          this.$store.dispatch("evacuees/updateData");
          this.$store.dispatch("evacuees/updateStatistics");
          this.evacueeident = "";
        })
        .catch((error) => {
          aerraudio.play();
          this.error = true;
          this.errorMessage = error.data.message;
          this.evacueeident = "";
        });
    },
    updateEvacuees: function () {
      this.$store.dispatch("evacuees/updateData");
      this.$store.dispatch("evacuees/updateLatestActiveEvacuationID");
      this.$store.dispatch("evacuees/updateStatistics");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@font-face {
  font-family: "password-mask";
  src: url(data:font/woff;charset:utf-8;base64,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)
    format("woff");
}
.hidden-text {
  font-family: password-mask;
  &:placeholder {
    font-family: Arial, Helvetica, sans-serif;
  }
}
</style>
